import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef } from "vue"

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import { batchEditTagContent } from '@/apis/order'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { fields } from './printTemplateData'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'printOptions', 'editTargetSku'],
  emits: ['update:visible', 'updateDeliverTaskDetails'],
  setup(__props, { emit }) {

const props = __props



const form = ref({} as any)
const circulateBackup = ref([] as any)
const formRef = ref()
const rules = ref({})
const validateUPC = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error(t('必填')))
  } else if (!/^[0-9]*$/g.test(value)) {
    callback(new Error(t('条形码必须为数字')))
  } else {
    callback()
  }
}
const getForm = () => {
  const cache = {} as any
  const { skuTagDTOList } = props.editTargetSku
  if (!skuTagDTOList) {
    return
  }
  // templateJson里没商品名的话得补上
  const productName = props.printOptions.templateJson.some(v => v.key === 'productName') ? [] : fields.filter(v => v.key === 'productName')
  const tagContent = JSON.parse(skuTagDTOList[0]?.tagContent ?? '[]')
  if (!tagContent.length) {
    return
  }
  // 手动补充商品名称
  props.printOptions.templateJson.filter((i:any) => i.field).concat(productName).forEach((i:any) => {
    cache[i.key] = Object.hasOwn(tagContent[0], i.key) ? tagContent[0][i.key] : ''
  })
  form.value = cache
  circulateBackup.value = props.printOptions.templateJson.filter((i:any) => i.field).concat(productName).map((v:any) => {
    return {
      key: v.key,
      label: v.name
    }
  })
  const rule = {} as any
  props.printOptions.templateJson.filter((i:any) => i.field).concat(productName).forEach((v:any) => {
    rule[v.key] = {
      required: true,
      trigger: 'blur',
      message: t('必填')
    }
  })
  // 手动补充下UPC规则
  rules.value = {
    ...rule,
    UPC: {
      required: true,
      trigger: 'blur',
      validator: validateUPC
    }
  }
}
getForm()
watch(() => props.editTargetSku, () => {
  getForm()
})
watch(() => props.printOptions, () => {
  getForm()
})
watch(() => props.visible, () => {
  getForm()
})

const commit = async () => {
  if (!await formRef.value.validate()) {
    return
  }
  const params = [
    {
      shopProductSku: props.editTargetSku.shopProductSku,
      tagContent: [form.value],
      type: 4
    }
  ]
  const res = await batchEditTagContent(params)
  if (res.success) {
    ElMessage.success(t('已完成'))
    emit('updateDeliverTaskDetails', {
      ...props.editTargetSku,
      skuTagDTOList: [{
        tagContent: JSON.stringify([form.value])
      }]
    })
    emit('update:visible', false)
  }
}

const cancel = () => {
  emit('update:visible', false)
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: __props.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    onOk: commit,
    onCancel: cancel,
    title: _unref(t)('编辑'),
    footer: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        rules: rules.value,
        "label-width": "100px",
        model: form.value
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(circulateBackup.value, (i, index) => {
            return (_openBlock(), _createBlock(_component_el_form_item, {
              label: i.label,
              prop: i.key,
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value[i.key],
                  "onUpdate:modelValue": ($event: any) => ((form.value[i.key]) = $event),
                  maxlength: "50",
                  style: {"width":"128px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["label", "prop"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})